import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { deleteLayout, DeleteLayoutPayload, layoutDeleted, layoutDeleteFailed } from '../../actions/layout/deleteLayout';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* deleteLayoutSaga({ payload }: Action<DeleteLayoutPayload>) {
  const { placeUuid, layoutUuid } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.deleteLayout, token, {
    placeUuid,
    layoutUuid,
  });
  if (!response.error) {
    const { affectedReservationDtos } = response;
    const affectedReservations = affectedReservationDtos.map(reservationFromDto);
    yield put(layoutDeleted({ layoutUuid, affectedReservations }));
  } else {
    yield put(layoutDeleteFailed({ layoutUuid }));
  }
}

export default function* watchDeleteLayoutSaga() {
  yield takeEvery(deleteLayout, deleteLayoutSaga);
}
